import {create} from "zustand";
import {DocData} from "../../pages/docs/model/docData";

export interface IDocsState {
    docs: DocData[];
    setDocs: (newData: DocData[]) => void;
}

export const docsStore = create<IDocsState>()((set) => ({
    docs: [],
    setDocs: (docs) => set(() => ({docs})),
}));
